(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@tableau/widgets"), require("@tableau/telemetry-api-contract"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@tableau/widgets", "@tableau/telemetry-api-contract"], factory);
	else if(typeof exports === 'object')
		exports["ButtonZoneComponentPlugin"] = factory(require("react"), require("@tableau/widgets"), require("@tableau/telemetry-api-contract"));
	else
		root["ButtonZoneComponentPlugin"] = factory(root["React"], root["SharedWidgets"], root["TelemetryAPIContract"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__197__, __WEBPACK_EXTERNAL_MODULE__729__, __WEBPACK_EXTERNAL_MODULE__669__) {
return 